export function hashString(message: string) {
	let hash = 0;

	if (message.length === 0) {
		return hash;
	}

	for (let i = 0; i < message.length; i++) {
		const ch = message.charCodeAt(i);
		hash = (hash << 5) - hash + ch;
		hash &= hash;
	}

	return hash;
}
